<script setup lang="ts">
import { useEventsRelated } from '~/api/drupal'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  categoryId?: number
  typeId?: number
  currentEventId?: number
}>()

const hasCategoryAndType = !!(props.categoryId && props.typeId)

const { items } = hasCategoryAndType
  ? await useEventsRelated({
      categoryId: [props.categoryId!.toString()],
      typeId: [props.typeId!.toString()],
      ...(props.currentEventId ? { currentEventId: [props.currentEventId.toString()] } : {}),
    })
  : { items: undefined }
</script>

<template>
  <SectionSpecial v-if="items?.length" :title="t('event.related.title')">
    <LinkListLarge>
      <template #default="{ isHovered }">
        <LinkListLargeItemEvent
          v-for="item in items"
          :key="item.id"
          v-animate="{ animation: 'vertical-reveal' }"
          :date="item.date"
          :title="item.title"
          :location="item.location"
          :link="item.link"
          :dim="isHovered"
        />
      </template>
    </LinkListLarge>
  </SectionSpecial>
</template>
